import PropTypes from 'prop-types';

import { Container } from '../Containers';

const UtilityNavigation = ({ ariaLabel, children, className, isCentered }) => (
  <header
    className={`border-b border-solid border-gray-2 bg-white z-navigation ${className}`}
  >
    <nav aria-label={ariaLabel} className="py-1">
      <Container isCentered={isCentered} type="widest">
        <div className="flex flex-wrap flex-row items-center justify-start">
          {children}
        </div>
      </Container>
    </nav>
  </header>
);

UtilityNavigation.defaultProps = {
  className: '',
  isCentered: false,
};

UtilityNavigation.propTypes = {
  /**
   * ARIA label for the overall navigation
   */
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  /**
   * Any custom CSS classes to add to the navigation
   */
  className: PropTypes.string,
  /**
   * Sets centering of container
   */
  isCentered: PropTypes.bool,
};

export default UtilityNavigation;
